import { render, staticRenderFns } from "./CiLogoFull.vue?vue&type=template&id=65bbf256&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports